import React from 'react';
import { VisualStat } from './VisualStat';
import type { WorkStat } from '../../../types/work';
type Props = {
  stat?: WorkStat;
};
export function BotkeeperVisual({
  stat
}: Props) {
  return <div aria-hidden className="absolute inset-0 bg-coral-soft" data-id="element-392" data-mp="3etbot8nal2nn">
      {stat && <VisualStat stat={stat} tone="rust" position="bottom" data-id="element-393" data-mp="3jklda5x3tzxy" />}
      <div className="absolute right-[8%] top-[14%] w-[58%] space-y-2.5 rounded-xl bg-white p-4 shadow-sm" data-id="element-394" data-mp="3jm4sruaxs6yo">
        {[0, 1, 2].map(row => <div key={row} className="flex items-center gap-3" data-id="element-395" data-mp="3sl01bd1gdt55">
            <span className={`h-5 w-5 shrink-0 rounded-full ${row === 0 ? 'bg-coral' : 'bg-line'}`} data-id="element-396" data-mp="3sjf7xqqvkg8v" />
            <span className="h-2 flex-1 rounded-full bg-line" data-id="element-397" data-mp="1fqlge76av99" />
            {row === 0 ? <span className="h-4 w-12 rounded-full bg-ink" data-id="element-398" data-mp="6da73z67aab8" /> : <span className="h-2 w-8 rounded-full bg-line" data-id="element-399" data-mp="237n385jxp1ch" />}
          </div>)}
      </div>
    </div>;
}